// extracted by mini-css-extract-plugin
export default {"empty-report":"empty-report--gpmT","content":"content--RJf+","no-data-text":"no-data-text--ESV3"};